import { createContextScope } from "@radix-ui/react-context";
export const PANEL_NAME = "Panel";
export const PANEL_CLOSE_NAME = "PanelClose";
export const PANEL_CONTENT_NAME = "PanelContent";
export const PANEL_TRIGGER_NAME = "PanelTrigger";
export const PANEL_OVERLAY_NAME = "PanelOverlay";
export const [createPanelContext, createPanelScope] = createContextScope(PANEL_NAME);
export const [PanelProvider, usePanelContext] = createPanelContext(PANEL_NAME);
